import React,{createContext, useState} from "react";
export const DashboardContext =createContext({})
